// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00015 1.58569L12.0002 4.58569L15.0002 1.58569L23.9144 10.4999L12.0002 22.4141L0.0859375 10.4999L9.00015 1.58569ZM10.5859 5.99991L9.00015 4.41412L2.91436 10.4999L12.0002 19.5857L12.9543 18.6315L10.5859 16.2632L12.0002 14.849L14.3685 17.2173L15.3227 16.2632L12.9543 13.8948L14.3685 12.4806L16.7369 14.849L18.0859 13.4999L15.0002 10.4141L12.0002 13.4141L7.58594 8.99991L10.5859 5.99991Z"}}]};

const CooperateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cooperate-filled',
    ref,
    icon: element,
  },
));

CooperateFilledIcon.displayName = 'CooperateFilledIcon';

export default CooperateFilledIcon;
